import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FilterListIcon from "@material-ui/icons/FilterList";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { mockMarkerInfo } from "./mockMarkerInfo";
import MockNewsComponent from "./MockNewsComponent";
import MockSearch from "./MockSearch";
import MockTooltipComponent from "./MockTooltipComponent";

const drawer = {
  filter: false,
  news: true,
};

const MockSideBar = ({ handleTooltip, open }) => {
  const news = mockMarkerInfo.data.marker_location.filter(
    (markerInfo) => markerInfo.marker_type === "news"
  );
  const history = useHistory();
  const styles = useStyles();
  const [page, SetPageName] = useState(null);
  const [openTooltip, setOpenTooltip] = useState(false);

  useEffect(() => {
    SetPageName(history.location.pathname.split("/")[2]);
  }, []);

  useEffect(() => {
    setOpenTooltip(open);
  }, [open]);

  return (
    <div>
      <Grid item xs={3} className={styles.sideBarHeader}>
        <Card className={styles.newshead}>
          <Grid container item spacing={2} style={{ marginBottom: "8px" }}>
            <Grid item xs={10}>
              <MockSearch />
            </Grid>
            <Grid
              item
              container
              xs={2}
              alignItems="flex-end"
              justifyContent="flex-end"
            >
              <IconButton
                aria-label="side"
                size="small"
                style={{ marginBottom: "8px" }}
              >
                <FilterListIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={3} className={styles.sideBarNews}>
        {news.length > 0 && (
          <React.Fragment>
            <Card className={styles.newshead}>
              <Grid style={{ display: "flex" }}>
                <Grid item xs={8}>
                  <h3 className={styles.filterText}>News</h3>
                </Grid>
                <Grid item xs={2}>
                  <h3 className={styles.filterText}>
                    {drawer.news ? "Hide" : "Show"}
                  </h3>
                </Grid>
                <Grid item xs={2} className={styles.downBtn}>
                  <IconButton
                    aria-label="side"
                    size="small"
                    className={styles.newsDrawer}
                  >
                    {drawer.news ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowUpIcon />
                    )}
                  </IconButton>
                </Grid>
              </Grid>
            </Card>

            <MockTooltipComponent
              placement="right-start"
              open={openTooltip}
              popper={styles.catchUpRiskTooltip}
              tooltipArrowStyle={styles.catchUpRiskArrow}
              title={
                <>
                  <Typography className={styles.tooltipTitleStyle}>
                    Catch up on global risks
                  </Typography>
                  <p className={styles.tooltipTextStyle}>
                    See how disruption might be affecting your suppliers.
                  </p>
                  <div
                    style={{
                      width: "64px",
                      padding: "8px",
                      backgroundColor: "#ffffff",
                      color: "#000000",
                      fontWeight: 600,
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenTooltip(false);
                      handleTooltip();
                    }}
                  >
                    <span>Continue</span>
                  </div>
                  <Typography className={styles.stepTextStyle}>
                    (16/19)
                  </Typography>

                </>
              }
              child={
                <Card className={styles.newsSection} id="news-section">
                  <MockNewsComponent page={"intelligence"} />
                </Card>
              }
            />
          </React.Fragment>
        )}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    maxHeight: "89vh",
  },
  sideBarHeader: {
    width: "21%",
    zIndex: "2",
    position: "absolute",
    top: "70px",
    borderRadius: "0px",
    maxHeight: "89vh",
    height: "auto",
    "& .MuiGrid-root": {
      maxWidth: "100%",
    },
  },
  sideBarNews: {
    zIndex: "1",
    position: "absolute",
    width: "21%",
    top: "210px",
    borderRadius: "0px",
    maxHeight: "89vh",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Inter",
    marginBottom: "8px",
  },
  catchUpRiskTooltip: {
    width: "375px",
    height: "140px",
    zIndex: 1,
  },
  catchUpRiskArrow: {
    marginTop: "-120px !important",
    top: '190px !important'
  },
  newsSection: {
    borderRadius: "0px",
    marginTop: "8px",
    height: "auto",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "50vh",
    transition: "2s !important",
  },
  downBtn: {
    "& .MuiButtonBase-root ": {
      left: "12%",
      marginTop: "2px",
    },
  },
  filterText: {
    margin: "0px",
    fontFSamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "6px 6px 6px 12px",
  },
  newshead: {
    borderRadius: "unset",
    boxShadow: "unset",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  }
}));

export default MockSideBar;
